import { GRAY_COLORS } from 'asterX-UI'

export default function CustomLabelY(props) {
  const { x, y } = props.viewBox

  return (
    <text
      x={x - 140}
      y={y - 10}
      fill={GRAY_COLORS[700]}
      fontSize={14}
      transform="rotate(-90)"
      textAnchor="end"
    >
      {props.value}
    </text>
  )
}
